const ACCOUNT_PERMISSION = Object.freeze({
	ADD_USERS: 'ACCOUNT_PERMISSION_ADD_USERS',
	EDIT_USERS: 'ACCOUNT_PERMISSION_EDIT_USERS',
	DELETE_USERS: 'ACCOUNT_PERMISSION_DELETE_USERS',
	EDIT_USER_ROLES: 'ACCOUNT_PERMISSION_EDIT_USER_ROLES',

	ADD_VEHICLES: 'ACCOUNT_PERMISSION_ADD_VEHICLES',
	EDIT_VEHICLES: 'ACCOUNT_PERMISSION_EDIT_VEHICLES',
	DELETE_VEHICLES: 'ACCOUNT_PERMISSION_DELETE_VEHICLES',

	ADD_OBJECT_PROPERTIES: 'ACCOUNT_PERMISSION_ADD_OBJECT_PROPERTIES',
	EDIT_OBJECT_PROPERTIES: 'ACCOUNT_PERMISSION_EDIT_OBJECT_PROPERTIES',
	DELETE_OBJECT_PROPERTIES: 'ACCOUNT_PERMISSION_DELETE_OBJECT_PROPERTIES',

	ADD_LOCATIONS: 'ACCOUNT_PERMISSION_ADD_LOCATIONS',
	EDIT_LOCATIONS: 'ACCOUNT_PERMISSION_EDIT_LOCATIONS',
	DELETE_LOCATIONS: 'ACCOUNT_PERMISSION_DELETE_LOCATIONS',

	ADD_ACCOUNT_ROLES: 'ACCOUNT_PERMISSION_ADD_ACCOUNT_ROLES',
	EDIT_ACCOUNT_ROLES: 'ACCOUNT_PERMISSION_EDIT_ACCOUNT_ROLES',
	DELETE_ACCOUNT_ROLES: 'ACCOUNT_PERMISSION_DELETE_ACCOUNT_ROLES',

	EDIT_RESERVATION: 'ACCOUNT_PERMISSION_EDIT_RESERVATION',
	CONFIRM_RESERVATION: 'ACCOUNT_PERMISSION_CONFIRM_RESERVATION',
	CANCEL_RESERVATION: 'ACCOUNT_PERMISSION_CANCEL_RESERVATION',

	ADD_DASHBOARD_VIEWS: 'ACCOUNT_PERMISSION_ADD_DASHBOARD_VIEWS',
	EDIT_DASHBOARD_VIEWS: 'ACCOUNT_PERMISSION_EDIT_DASHBOARD_VIEWS',
	DELETE_DASHBOARD_VIEWS: 'ACCOUNT_PERMISSION_DELETE_DASHBOARD_VIEWS',

	ADD_BRANDS: 'ACCOUNT_PERMISSION_ADD_BRANDS',
	EDIT_BRANDS: 'ACCOUNT_PERMISSION_EDIT_BRANDS',
	DELETE_BRANDS: 'ACCOUNT_PERMISSION_DELETE_BRANDS',

	ADD_PAYMENTS: 'ACCOUNT_PERMISSION_ADD_PAYMENTS',
	EDIT_PAYMENTS: 'ACCOUNT_PERMISSION_EDIT_PAYMENTS',
	DELETE_PAYMENTS: 'ACCOUNT_PERMISSION_DELETE_PAYMENTS',

	ADD_EXPENSES: 'ACCOUNT_PERMISSION_ADD_EXPENSES',
	EDIT_EXPENSES: 'ACCOUNT_PERMISSION_EDIT_EXPENSES',
	DELETE_EXPENSES: 'ACCOUNT_PERMISSION_DELETE_EXPENSES',

	ADD_DOCUMENTS: 'ACCOUNT_PERMISSION_ADD_DOCUMENTS',
	EDIT_DOCUMENTS: 'ACCOUNT_PERMISSION_EDIT_DOCUMENTS',
	DELETE_DOCUMENTS: 'ACCOUNT_PERMISSION_DELETE_DOCUMENTS',

	ADD_LAYOUTS: 'ACCOUNT_PERMISSION_ADD_LAYOUTS',
	EDIT_LAYOUTS: 'ACCOUNT_PERMISSION_EDIT_LAYOUTS',
	DELETE_LAYOUTS: 'ACCOUNT_PERMISSION_DELETE_LAYOUTS',

	REPORTING: 'ACCOUNT_PERMISSION_REPORTING',

	ADD_PROPOSALS: 'ACCOUNT_PERMISSION_ADD_PROPOSALS',
	EDIT_PROPOSALS: 'ACCOUNT_PERMISSION_EDIT_PROPOSALS',
	DELETE_PROPOSALS: 'ACCOUNT_PERMISSION_DELETE_PROPOSALS',
})

module.exports = {
	ACCOUNT_PERMISSION,
}
